

export const date_formats = [
    "dd-MM-yy",
    "dd-MM-yy HH:mm",
    "MM/dd/yy",
    "MM-dd-yy",
    "MMMM d yyyy",
    "MM-dd-yyyy",
    "dd/MM/yyyy",
    "d MMM yyyy",
    "MM/dd/yy HH:mm"
]